<template>
  <v-layout max-width class="flex-column white" style="min-height: 100%">
    <div
      class="flex-y-center flex-justify-between px-2"
      style="border-bottom: 1px solid #e8e8e8"
    >
      <v-tabs v-model="tab">
        <v-tab :href="`#1`">系统</v-tab>
        <v-tab :href="`#2`">首页</v-tab>
      </v-tabs>
    </div>
    <div v-if="tab === '1'" class="flex-1 px-12 mt-12 pt-12">
      <v-row
        v-for="(item, index) in commonInfo"
        :key="index"
        no-gutters
        class="flex-y-center mb-8"
      >
        <v-col cols="12" sm="4" md="4" class="flex-justify-end">
          {{ item.desc }}：
        </v-col>
        <v-col cols="12" sm="6" md="6" class="flex-y-center">
          <form-item
            v-model="data[item.key]"
            :placeholder="item.desc"
            type="text"
            allow-close
            @input="$forceUpdate()"
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="flex-y-center mb-8">
        <v-col cols="12" sm="4" md="4" class="flex-justify-end" />
        <v-col cols="12" sm="6" md="6">
          <v-btn
            color="primary"
            depressed
            class="mt-4"
            height="32"
            width="100"
            @click="submit"
          >保存</v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <home-page-setting />

      <!-- <v-row
        v-if="commonInfo.length"
        no-gutters
        class="flex-y-center mb-8"
      >
        <v-col
          cols="12"
          sm="4"
          md="4"
          class=" flex-justify-end"
        />
        <v-col
          cols="12"
          sm="6"
          md="6"
        >
          <v-btn
            color="primary"
            depressed
            class="mt-4"
            height="32"
            width="100"
            @click="submit"
          >保存</v-btn>
        </v-col>
      </v-row> -->
    </div>
  </v-layout>
</template>

<script>
import homePageSetting from './homePageSetting.vue';
export default {
  components: { homePageSetting },
  data() {
    return {
      companyNameEnColorPickerShow: false,
      tab: '1',
      search: {
        pageSize: 10,
        pageNo: 1,
        data: {},
      },
      data: {},
      commonInfo: [],
      shiyan: [],
      form: {
        companyNameEn: '',
        companyNameEnFont: '',
        companyNameEnSize: '',
        companyNameEnColor: '',
        systemNameEn: '',
        systemNameEnFont: '',
        systemNameEnSize: '',
        systemNameEnColor: '',
        systemNameCn: '',
        systemNameCnFont: '',
        systemNameCnSize: '',
        systemNameCnColor: '',
        systemDesc: '',
        systemDescFont: '',
        systemDescSize: '',
        systemDescColor: '',
        systemCopyRightInformation: '',
        systemCopyRightInformationFont: '',
        systemCopyRightInformationSize: '',
        systemCopyRightInformationColor: '',
      },
    };
  },
  mounted() {
    this.settingGetCommonInfo();
  },
  methods: {
    // 获取信息
    settingGetCommonInfo() {
      this.$http
        .get(this.$api.settingGetCommonInfo, { data: '' })
        .then((res) => {
          this.commonInfo = res.result || [];
          this.commonInfo.forEach((item) => {
            this.data[item.key] = item.value;
          });
        });
    },
    // 保存
    submit() {
      this.$http
        .post(this.$api.settingSaveCommonInfo, { data: this.data })
        .then((res) => {
          this.$message.success(res.message);
        });
    },
    onHomePageSubmit() {},
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  width: 130px;
  color: #777;
}
.colorPickerButton {
  height: 32px;
  width: 32px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
</style>
